module.exports = "/assets/site/images/icon-password-yellow.png?56bf8bcdf549d093f7b7d68f63acf610";